import { useState } from "react";
import axios from "axios";
import { ArrowRight, KeyRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PasswordResetPage() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true); setError(""); setMessage("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setMessage("Password updated. You can sign in with your new password now.");
    } catch (requestError) {
      const detail = requestError.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "This reset link is no longer valid.");
    } finally { setBusy(false); }
  };
  return (
    <main className="result-page reset-page" data-testid="password-reset-page">
      <div className="result-mark"><KeyRound size={27} /></div>
      <p className="eyebrow">Bicycle Parts Direct / Account desk</p>
      <h1 data-testid="password-reset-heading">Create a new password.</h1>
      {!token ? <p className="form-error" data-testid="password-reset-missing-token">This reset link is missing its token.</p> : message ? <p className="reset-success" data-testid="password-reset-success-message">{message}</p> : <form className="auth-form reset-form" onSubmit={submit}><label>New password<input type="password" minLength="8" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="8 characters minimum" autoComplete="new-password" data-testid="password-reset-new-password-input" required /></label>{error && <p className="form-error" data-testid="password-reset-error">{error}</p>}<button className="button button-primary auth-submit" type="submit" disabled={busy} data-testid="password-reset-submit-button">{busy ? "Updating password…" : "Update password"} <ArrowRight size={17} /></button></form>}
      <a className="button button-ghost" href={message ? "/?auth=login" : "/"} data-testid="password-reset-return-link">{message ? "Sign in to your account" : "Return to Bicycle Parts Direct"}</a>
    </main>
  );
}
